import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./blog-details.css";
// import FloatingImage from "./assests/AIicon.png";
import FloatingAIButton from "./components/FloatingAIButton";
import Modal from "./Modal";
import API_BASE_URL from "./config/api";

function BlogDetails() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${API_BASE_URL}/blogs/slug/${slug}`)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 404) {
            return fetch(`${API_BASE_URL}/blogs/${slug}`);
          }
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        return response;
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }
        return response.json();
      })
      .then((result) => {
        setBlog(result);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blog details:", error);
        setError(error.message);
        setIsLoading(false);
      });
  }, [slug]);

  /* 
  const styles = {
    floatingBox: {
      position: "fixed",
      bottom: "20px",
      right: "115px",
      width: "96px",
      height: "96px",
      display: "flex",
      borderRadius: "15px",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10,
    },
    floatingButton: {
      border: "none",
      backgroundColor: "transparent",
      padding: 0,
      cursor: "pointer",
      borderRadius: "15px",
    },
    floatingImage: {
      width: "96px",
      height: "96px",
      objectFit: "cover",
      borderRadius: "15px",
    },
  }; 
  */

  if (isLoading) {
    return (
      <>
        <Navbar />
        <div className="loading-container">
          <div className="loading-spinner">Loading...</div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !blog) {
    return (
      <>
        <Navbar />
        <div className="error-container">
          <h2>Error loading blog</h2>
          <p>{error || "The blog you're looking for doesn't exist."}</p>
        </div>
        <Footer />
      </>
    );
  }

  const descriptionImages = blog.descriptionImage?.split(",") || [];

  return (
    <>
      <Helmet>
        <title>{`${blog.title} | Trippro Blog`}</title>
        <meta name="description" content={blog.metaDescription || blog.title} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.trippro.in/blog/${slug}`} />
        {/* Open Graph tags */}
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.metaDescription || blog.title} />
        <meta property="og:image" content={blog.titleImage} />
        <meta property="og:url" content={`https://www.trippro.in/blog/${slug}`} />
        <meta property="og:type" content="article" />
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.metaDescription || blog.title} />
        <meta name="twitter:image" content={blog.titleImage} />
      </Helmet>

      <Navbar />
      <div className="blog-details-container">
        <img src={blog.titleImage} alt={blog.title} className="blog-title-image" />
        <div className="blog-title">{blog.title}</div>
        <div className="blog-description" dangerouslySetInnerHTML={{ __html: blog.description }} />
        <div className="description-images-container">
          {descriptionImages.map((imageUrl, index) => (
            <img
              key={index}
              src={imageUrl.trim()}
              alt={`Description Image ${index + 1}`}
              className="description-image"
            />
          ))}
        </div>
      </div>
      <Footer />

      {/* Floating Widget */}
      <FloatingAIButton onClick={openModal} />

      {isModalOpen && <Modal closeModal={closeModal} />}
    </>
  );
}

export default BlogDetails;